import { useEffect } from 'react';
function createI18nBackend(importLocale) {
    return {
        type: 'backend',
        read: async (language, _namespace, callback) => {
            try {
                return callback(null, await importLocale(language));
            }
            catch (e) {
                return callback(e, null);
            }
        },
    };
}
export const useInitI18n = (options) => {
    const { i18n, importLocale } = options;
    useEffect(() => {
        i18n.use(createI18nBackend(importLocale));
        i18n.init({ react: { useSuspense: true } });
    }, [i18n]);
};
//# sourceMappingURL=useI18n.js.map